/*
 * Copyright (c) 2024 CalAmp Corp. All Rights Reserved
 */

export const NO_GROUP_ID = -1;
